import {AUTO_PREFIX} from "@/constants";

export const CompactNumber = ({e164, shortNumber}: {shortNumber: string; e164: string}) => {
    if (e164) {
        if (e164.startsWith(AUTO_PREFIX)) return <>{shortNumber}</>;
        if (e164.endsWith(shortNumber))
            return (
                <>
                    {e164.replace(shortNumber, "")}
                    <span style={{fontWeight: "bold"}}>{shortNumber}</span>
                </>
            );
        else
            return (
                <>
                    {e164} / {shortNumber}
                </>
            );
    }

    return <>{shortNumber}</>;
};
